import HeroSearch from './HeroSearch';
import HeroPreviewCard from './HeroPreviewCard';
import TrustBadges from './TrustBadges';
import { t } from '../../utils/i18n';

export default function HeroSection({
  searchMode,
  onSearchModeChange,
  searchQuery,
  onSearchQueryChange,
  onLocationSelect,
  onSearch,
  locationAutocompleteRef,
  children,
}) {
  return (
    <section className="relative overflow-visible pt-8 sm:pt-12 lg:pt-14 pb-6 sm:pb-10 lg:pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 xl:gap-16 items-center">
          <div className="text-center lg:text-left animate-fade-in">
            <h1 className="text-3xl sm:text-4xl md:text-[2.75rem] lg:text-5xl font-semibold tracking-tight leading-[1.15] mb-4">
              <span className="text-primary-600 dark:text-primary-400">
                {t('landing.hero.title')}
              </span>
              <br />
              <span className="text-[var(--color-text)]">
                {t('landing.hero.subtitle')}
              </span>
            </h1>
            <p
              className="text-base sm:text-lg text-[var(--color-text-muted)] mb-6 sm:mb-8 max-w-xl mx-auto lg:mx-0 leading-relaxed animate-fade-in"
              style={{ animationDelay: '0.1s' }}
            >
              {t('landing.hero.descriptionShort')}
            </p>

            <div className="max-w-xl mx-auto lg:mx-0">
              <HeroSearch
                searchMode={searchMode}
                onSearchModeChange={onSearchModeChange}
                searchQuery={searchQuery}
                onSearchQueryChange={onSearchQueryChange}
                onLocationSelect={onLocationSelect}
                onSearch={onSearch}
                locationAutocompleteRef={locationAutocompleteRef}
              />
            </div>

            <div className="mt-6 hidden sm:block">
              <TrustBadges />
            </div>
          </div>

          <div className="hidden md:block lg:pl-4">
            <HeroPreviewCard />
          </div>
        </div>

        {children && (
          <div className="mt-8 sm:mt-10 w-full max-w-[1600px] mx-auto animate-fade-in relative z-20">
            {children}
          </div>
        )}

        <div className="mt-6 sm:hidden flex justify-center">
          <TrustBadges />
        </div>
      </div>
    </section>
  );
}
